import React from 'react';

const Logo = ({ size = 'medium', showText = true, className = '' }) => {
  const sizes = {
    small: { width: '32px', height: '32px', fontSize: '1rem' },
    medium: { width: '48px', height: '48px', fontSize: '1.25rem' },
    large: { width: '64px', height: '64px', fontSize: '1.5rem' },
    xlarge: { width: '128px', height: '128px', fontSize: '2rem' }
  };

  const logoStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    fontWeight: '600',
    color: '#2d3748'
  };

  const imageStyle = {
    ...sizes[size],
    objectFit: 'contain'
  };

  return (
    <div className={className} style={logoStyle}>
      <img 
        src="/logo512.png" 
        alt="Gaming Assistant Logo" 
        style={imageStyle}
      />
      {showText && (
        <span style={{ fontSize: sizes[size].fontSize }}>
          Miskatonic.Academy
        </span>
      )}
    </div>
  );
};

export default Logo;